import { render } from "./loading.vue?vue&type=template&id=12e3a8cc"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=12e3a8cc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__